import { Injectable } from '@angular/core';
import { Store } from '@fc-core/store-utils/store';
import { CameraEventConnection } from '../models/camera-event-connection';
import { CameraOverview } from 'src/app/cameras/models/camera-overview';
import { CameraEventSnapshot } from '../models/camera-event-snapshot';

export interface CameraStatusState {
  cameraStatus: { [cameraId: number]: CameraEventConnection };
  cameraSnapshots: { [cameraId: number]: CameraEventSnapshot };
}

const initialState: CameraStatusState = {
  cameraStatus: {},
  cameraSnapshots: {},
};

@Injectable({
  providedIn: 'root',
})
export class CameraStatusStore extends Store<CameraStatusState> {
  constructor() {
    super(initialState);
  }

  getCameraSnapshots(cameraId: number): CameraEventSnapshot {
    return this.selectors.cameraSnapshots()[cameraId];
  }

  setCameraStatus(
    cameraId: number,
    status: Partial<CameraEventConnection>,
  ): void {
    this.draftUpdate((state) => {
      state.cameraStatus[cameraId] = {
        ...state.cameraStatus[cameraId],
        ...status,
        cameraId,
      };
    });
  }

  setCameraSnapshot(cameraId: number, snapshot: CameraEventSnapshot): void {
    this.draftUpdate((state) => {
      state.cameraSnapshots[cameraId] = snapshot;
    });
  }

  setFromOverview(cameraOverview: CameraOverview[]): void {
    if (!cameraOverview) return;
    this.draftUpdate((state) => {
      cameraOverview.forEach((camera) => {
        state.cameraStatus[camera.camera.id] = {
          cameraId: camera.camera.id,
          status: camera.camera.isOnline ? 'online' : 'offline',
          recordingStatus:
            state.cameraStatus[camera.camera.id]?.recordingStatus ??
            camera.camera.recordingStatus,
        };

        if (camera.latest?.datetime) {
          state.cameraSnapshots[camera.camera.id] = {
            cameraId: camera.camera.id,
            datetime: camera.latest.datetime,
          };
        }
      });
    });
  }
}
